export const CookieName = {
  EXPERIMENTATION_USER_ID: 'features-user-id',
  MASTER_ID: 'master_id',
  IDENTITY_COOKIE: 'identity.cdn.logged_in',
  WM_COOKIE_NAME: 'Wm'
} as const
